// frontend/src/components/PositionTracker.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadPositions } from '../redux/slices/tradingSlice';

const PositionTracker = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { positions } = useSelector((state) => state.trading);

  useEffect(() => {
    if (user?.uid) {
      dispatch(loadPositions(user.uid));
    }
  }, [user]);

  if (positions.length === 0) {
    return (
      <div className="card">
        <div className="card-header">
          <h2>Open Positions</h2>
        </div>
        <p className="text-muted">No open positions</p>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h2>Open Positions ({positions.length})</h2>
      </div>
      <div className="positions-table">
        <table>
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Type</th>
              <th>Entry Price</th>
              <th>Current Price</th>
              <th>Volume</th>
              <th>Profit/Loss</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {positions.map(pos => (
              <tr key={pos.id} className={pos.type === 'BUY' ? 'buy-row' : 'sell-row'}>
                <td>{pos.symbol}</td>
                <td className={pos.type === 'BUY' ? 'buy-text' : 'sell-text'}>{pos.type}</td>
                <td>{pos.entryPrice?.toFixed(5)}</td>
                <td>{pos.currentPrice?.toFixed(5)}</td>
                <td>{pos.volume}</td>
                <td className={pos.profit >= 0 ? 'profit' : 'loss'}>
                  ${pos.profit?.toFixed(2)}
                </td>
                <td>{pos.openTime ? new Date(pos.openTime).toLocaleTimeString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PositionTracker;